import React from 'react'
import { TextField, Autocomplete, Typography, CircularProgress, Box } from '@mui/material'
import styled from 'styled-components'
import { InputProps } from '@/types/input.types'
import CustomView from './CustomView'

const CustomTexField = styled(TextField)`
  & label.Mui-focused {
    color: #142954;
  }
  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: #142954;
    }
  }
  & .MuiInputBase-input {
    font-size: 14px;
    color: #2c2c2c;
  }
  & .MuiInputLabel-outlined {
    font-size: 14px;
  }
  & .MuiOutlinedInput-notchedOutline {
    font-size: 12px;
  }
  &.MuiSelect-select {
    min-height: 1.1em !important;
    max-height: 1.1em !important;
    margin-top: 2px;
  }

  .MuiAutocomplete-endAdornment {
    top: calc(50% - 10px) !important;
  }

  .MuiAutocomplete-inputRoot.Mui-disabled {
    background-color: #f8f8fa;
  }
`

const CustomEndAdornment = styled(Box)`
  && {
    display: contents;
    .MuiAutocomplete-endAdornment {
      right: 32px !important;
    }
  }
`

export default function FormSelect({
  name,
  value,
  options = [],
  label,
  onChange,
  onOpen = () => {},
  withBorder = false,
  errorMessage,
  helperText,
  disabled,
  id,
  optionLabel,
  renderOption = undefined,
  loading = false,
  endAdornment = undefined,
  placeholder,
}: InputProps) {
  const handleOptionLabel = (option: any) => {
    if (optionLabel && typeof option === 'object') return option[optionLabel]
    if (option?.length) return option

    return ''
  }

  const handleOptionEqualValue = (option: any, value: any) => {
    if (typeof option === 'object') return option[String(optionLabel)] === value

    return option === value
  }

  return (
    <CustomView style={{ pointerEvents: disabled ? 'none' : 'auto' }}>
      <Autocomplete
        value={value}
        className={name}
        id={id}
        options={options}
        freeSolo
        forcePopupIcon={true}
        onOpen={(e: any) => onOpen(e)}
        onChange={(e: any, value: string) => onChange(id, value ?? '')}
        getOptionLabel={handleOptionLabel}
        isOptionEqualToValue={handleOptionEqualValue}
        renderOption={renderOption}
        disabled={disabled}
        noOptionsText="Não encontrado"
        style={{
          width: '100%',
          background: 'white',
          maxHeight: '52px',
        }}
        renderInput={(params) => (
          <CustomTexField
            {...params}
            sx={{
              '.MuiOutlinedInput-notchedOutline': {
                border: withBorder ? '' : 'unset',
              },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {endAdornment ? (
                    <CustomEndAdornment>
                      {params.InputProps.endAdornment}
                      {endAdornment}
                    </CustomEndAdornment>
                  ) : (
                    params.InputProps.endAdornment
                  )}
                </React.Fragment>
              ),
            }}
            variant="outlined"
            label={label}
            placeholder={placeholder}
          />
        )}
      />
      {errorMessage ? (
        <Typography fontSize="12px" color="red" mt="2px">
          {errorMessage}
        </Typography>
      ) : (
        helperText && (
          <Typography fontSize="12px" color="#00000099" mt="3px" ml="14px">
            {helperText}
          </Typography>
        )
      )}
    </CustomView>
  )
}
